/**
 * Why the app does not list this audiobook session, or null if it does.
 *
 * The editor lists every active and inactive session linked to the book
 * (deleted ones never come back from the API). The app lists only active
 * ones (APIv2 #931), so a retired chapter can look like an "extra session"
 * here. Older API payloads have no flag: treat them as listed.
 */
export function hiddenChapterReason(session) {
  if (session?.session_is_active === false) return "Inactive";
  return null;
}

/** Total length in seconds of the sessions the app plays. */
export function playableLengthSec(sessions) {
  return (sessions || []).reduce((total, s) => {
    if (hiddenChapterReason(s)) return total;
    const sec = Number(s?.session_length_in_sec) || 0;
    return sec > 0 ? total + sec : total;
  }, 0);
}
